import React, { useEffect } from "react";
import { X, Calendar } from "lucide-react";
import Cal, { getCalApi } from "@calcom/embed-react";

// TODO: Sostituire con il link Cal.com di Francesco (username/event-slug)
// Esempio: "mydigitalaction/call-gratuita"
// Dopo aver creato l'account su cal.com e collegato Google Calendar
export const CAL_LINK = "frank-gheri/30min";

export default function BookingModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    (async () => {
      const cal = await getCalApi({ namespace: "call-gratuita" });
      cal("ui", {
        theme: "dark",
        cssVarsPerTheme: {
          dark: {
            "cal-brand": "#d4ff3d",
            "cal-bg": "#0f0f0f",
            "cal-bg-emphasis": "#141414",
            "cal-bg-muted": "#111111",
            "cal-border": "rgba(255,255,255,0.1)",
            "cal-border-subtle": "rgba(255,255,255,0.06)",
            "cal-text": "#f5f5f5",
            "cal-text-emphasis": "#ffffff",
            "cal-text-muted": "rgba(255,255,255,0.6)",
          },
        },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, [open]);

  // Prevent body scroll when open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-2 sm:p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-4xl max-h-[95vh] overflow-hidden bg-[#0f0f0f] border border-white/10 rounded-2xl shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 lg:px-8 py-4 border-b border-white/10 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
              <Calendar size={16} className="text-white" />
            </div>
            <div>
              <div className="font-mono-label text-white/40 text-[10px]">Call gratuita — 30 min</div>
              <div className="font-display text-white text-lg lg:text-xl mt-0.5">
                Parla con un ns consulente
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:text-white hover:border-white/40 transition-colors"
            aria-label="Chiudi"
          >
            <X size={16} />
          </button>
        </div>

        {/* Cal.com Embed */}
        <div className="flex-1 overflow-hidden bg-[#0f0f0f]">
          <Cal
            namespace="call-gratuita"
            calLink={CAL_LINK}
            style={{ width: "100%", height: "100%", minHeight: "620px", overflow: "auto" }}
            config={{ layout: "month_view", theme: "dark" }}
          />
        </div>

        {/* Footer info */}
        <div className="px-5 lg:px-8 py-3 border-t border-white/10 flex items-center justify-between flex-wrap gap-2 text-[11px] text-white/50 flex-shrink-0">
          <span>
            Fuso orario: <span className="text-white/70">Europe/Rome (GMT+1)</span>
          </span>
          <span>Sync bidirezionale con Google Calendar • Email di conferma automatica</span>
        </div>
      </div>
    </div>
  );
}
